import CtaBox from './ctaBox';

export default CtaBox;
export { ctaBoxFragment } from './ctaBox.fragment';
export { ctaBoxStandard } from './__fixtures__/ctaBox';
